import { take, put, call, all, takeLatest } from 'redux-saga/effects';
import moment from 'moment';

import {
    initMemberInfo,

    getMemberDetailStart,
    getMemberDetailSuccess,
    getMemberDetailFail,

    searchMemberStart,
    searchMemberSuccess,
    searchMemberFail,

    getMemberAddressStart,
    getMemberAddressSuccess,
    getMemberAddressFail,

    getMemberAddressDetailStart,
    getMemberAddressDetailSuccess,
    getMemberAddressDetailFail,

    cartEditFail,
    cartEditStart,
    cartEditSuccess,

    cartGetListStart,
    cartGetListFail,
    cartGetListSuccess,

    cartRemoveFail,
    cartRemoveStart,
    cartRemoveSuccess,

    cartMultipleRemoveFail,
    cartMultipleRemoveStart,
    cartMultipleRemoveSuccess,

    getMemberProfileStart,
    getMemberProfileSuccess,
    getMemberProfileFail,

} from '../actions/member';

import requestManagement from '../service/requestManagement';
const { method_POST, method_GET, method_PUT, method_PATCH, method_MULTIPLE_EDIT_CART, method_MULTIPLE_REMOVE_CART } = requestManagement;

import CONFIG from '@root/config/config.next';
/*console.log("CONFIG", CONFIG.jnzAuthConfig)*/
const url = CONFIG.jnzAuthConfig.authEndpoint
const base_url = CONFIG.backendEndpoint

export function* getMemberDetail({ payload }) {

    /*console.log('[sages] getMemberDetail : ', payload);*/

    const apiURL = `${url}/member/v1/account/${payload?.data?.member_uuid}`;
    // https://cloud-api.zeus.jenosize.dev/crm/v1/customer/cbe586f7-12bf-4a0f-8057-f12733a59b20/member/providerProfile

    //====================================================================================================================

    try {
        const data = yield method_GET({
            url: apiURL,
        }
        );

        /*console.log("[API] GET: ", data);*/

        yield put(getMemberDetailSuccess(data));

    } catch (error) {
        yield put(getMemberDetailFail(error));
    }

    //====================================================================================================================

}

export function* searchMember({ payload }) {

    /*console.log('[sages] searchMember : ', payload);*/

    const apiURL = `${url}/member/v1/account/search`;

    //====================================================================================================================

    try {
        const data = yield method_POST({
            url: apiURL,
            data: payload?.data
        }
        );

        /*console.log("[API] GET : ", data);*/

        yield put(searchMemberSuccess(data));

    } catch (error) {
        yield put(searchMemberFail(error));
    }

    //====================================================================================================================

}

export function* getMemberAddress({ payload }) {

    /*console.log('[sages] getMemberAddress : ', payload);*/

    // const apiURL = `${url}/member/v1/account/${payload?.data?.member_uuid}/address/list`;

    const apiURL = `${url}/member/v1/account/${payload?.data?.member_uuid}/address/list?expand[]=address&json[]=address`;

    //====================================================================================================================

    try {
        const data = yield method_GET({
            url: apiURL,
        }
        );

        /*console.log("[API] GET: ", data);*/

        yield put(getMemberAddressSuccess(data));

    } catch (error) {
        yield put(getMemberAddressFail(error));
    }

    //====================================================================================================================

}

export function* getMemberAddressDetail({ payload }) {

    /*console.log('[sages] getMemberAddressDetail : ', payload);*/

    const apiURL = `${url}/member/v1/account/${payload?.data?.member_uuid}/address/${payload?.data?.address_uuid}`;

    //====================================================================================================================

    try {
        const data = yield method_GET({
            url: apiURL,
        }
        );

        /*console.log("[API] GET: ", data);*/

        yield put(getMemberAddressDetailSuccess(data));

    } catch (error) {
        yield put(getMemberAddressDetailFail(error));
    }

    //====================================================================================================================

}

export function* cartGetList({ payload }) {

    /*console.log('[sages] cartGetList : ', payload);*/
    // const apiURL = `${base_url}/backend/v1/order/cart`;
    const apiURL = (payload?.active_v2) ? `${base_url}/backend/v2/order/cart` : `${base_url}/backend/v1/order/cart`;

    //====================================================================================================================

    try {
        const data = yield method_POST({
            url: apiURL,
            data: {
                "branch_code": payload?.branch_code,
                "member_uuid": payload?.member_uuid,
            }
        }
        );

        /*console.log("[API] POST: ", data);*/

        yield put(cartGetListSuccess(data));

    } catch (error) {
        yield put(cartGetListFail(error));
    }

    //====================================================================================================================

}


export function* cartEdit({ payload }) {

    /*console.log('[sages] cartEdit : ', payload);*/

    const apiURL = `${base_url}/backend/v1/order/cart`;

    //====================================================================================================================

    try {
        const data = yield method_MULTIPLE_EDIT_CART({
            url: apiURL,
            array: payload?.array,
        }
        );

        /*console.log("[API] PUT CART: ", data);*/

        yield put(cartEditSuccess(data));

    } catch (error) {
        yield put(cartEditFail(error));
    }

    //====================================================================================================================

}

export function* cartRemove({ payload }) {

    /*console.log('[sages] cartRemove : ', payload);*/

    const apiURL = `${base_url}/backend/v1/order/cart`;

    //====================================================================================================================

    try {
        const data = yield method_PATCH({
            url: apiURL,
            data: {
                "branch_code": payload?.branch_code,
                "member_uuid": payload?.member_uuid,
                "product_sku_uuid": payload?.product_sku_uuid,
                "status": -1
            }
        }
        );

        /*console.log("[API] PATCH: ", data);*/

        yield put(cartRemoveSuccess(data));

    } catch (error) {
        yield put(cartRemoveFail(error));
    }

    //====================================================================================================================

}

export function* cartMultipleRemove({ payload }) {

    /*console.log('[sages] cartMultipleRemove : ', payload);*/

    const apiURL = `${base_url}/backend/v1/order/cart`;

    //====================================================================================================================

    try {
        const data = yield method_MULTIPLE_REMOVE_CART({
            url: apiURL,
            array: payload?.array,
            data: {}
        }
        );

        /*console.log("[API] PATCH: ", data);*/

        yield put(cartMultipleRemoveSuccess(data));

    } catch (error) {
        yield put(cartMultipleRemoveFail(error));
    }

    //====================================================================================================================

}

export function* getMemberProfile({ payload }) {

    console.log('[sages] getMemberProfile : ', payload);

    const apiURL = `${base_url}/backend/v2/member/member`;

    //====================================================================================================================

    try {

        const { member_uuid } = payload || {};

        const data = yield method_POST({
            url: apiURL,
            data: { member_uuid }
        }
        );

        /*console.log("[API] GET : ", data);*/

        yield put(getMemberProfileSuccess(data));

    } catch (error) {
        yield put(getMemberProfileFail(error));
    }

    //====================================================================================================================

}

export function* watchMember() {

    /*console.log('[sages] watchMember : ✅');*/

    yield all([
        takeLatest(getMemberDetailStart, getMemberDetail),
        takeLatest(searchMemberStart, searchMember),
        takeLatest(getMemberAddressStart, getMemberAddress),
        takeLatest(getMemberAddressDetailStart, getMemberAddressDetail),
        takeLatest(cartGetListStart, cartGetList),
        takeLatest(cartEditStart, cartEdit),
        takeLatest(cartRemoveStart, cartRemove),
        takeLatest(cartMultipleRemoveStart, cartMultipleRemove),
        takeLatest(getMemberProfileStart, getMemberProfile)
    ])
}



